import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import api from "@/lib/api";
import { toast } from "sonner";

export const LikeButton = ({ targetType, targetId, liked: initialLiked, count: initialCount }) => {
  const [liked, setLiked] = useState(initialLiked);
  const [count, setCount] = useState(initialCount || 0);
  const { user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  const toggle = async () => {
    if (!user) {
      toast.info(t("guest_interact_prompt"));
      return navigate("/register");
    }
    const prevLiked = liked;
    const prevCount = count;
    setLiked(!prevLiked);
    setCount(prevCount + (prevLiked ? -1 : 1));
    try {
      const { data } = await api.post(`/likes/${targetType}/${targetId}`);
      setLiked(data.liked);
      setCount(data.count);
    } catch {
      setLiked(prevLiked);
      setCount(prevCount);
    }
  };

  return (
    <button
      data-testid="like-btn"
      onClick={toggle}
      className={`flex items-center gap-1.5 text-sm transition-colors ${liked ? "text-red-500" : "text-muted-foreground hover:text-foreground"}`}
    >
      <Heart className={`h-[18px] w-[18px] transition-transform active:scale-125 ${liked ? "fill-red-500" : ""}`} />
      {count > 0 && <span data-testid="like-count" className="font-mono-data text-xs">{count}</span>}
    </button>
  );
};
